module.exports = __webpack_public_path__ + "static/img/晴.656bc2d3.svg";